module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("vuex 测试")]), _vm._v("\n  Clicked: " + _vm._s(_vm.getCount) + " times\n  "), _c('button', {
    on: {
      "click": _vm.increment
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.decrement
    }
  }, [_vm._v("-")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4567c20a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav2/Page4.vue
// module id = 1042
// module chunks = 1